module.exports = __webpack_public_path__ + "static/media/sky_1.3435d13f.jpg";